import type { NavigateFunction } from 'react-router'
import type { To } from './hooks'

// SEAM: imperative navigation outside React components. v6 owns history and has
// no global navigate, so <NavigationBridge> registers the router's `navigate`
// fn here at mount. Calls before registration are no-ops.
let registered: NavigateFunction | null = null

export function registerNavigate(fn: NavigateFunction) {
  registered = fn
}

export const navigate = {
  push: (to: To, state?: unknown) => registered?.(to as string, { state }),
  replace: (to: To, state?: unknown) =>
    registered?.(to as string, { replace: true, state }),
  go: (delta: number) => registered?.(delta),
  back: () => registered?.(-1),
}
